export default __webpack_public_path__ + "static/media/ICS-main.e0d2c01a.png";